module.exports = __webpack_public_path__ + "img/friendly-room.a9d2aa88.jpg";